
export class AppUserInterface {

    public isSearchRunning:              boolean = false;

    public readonly epSnowContainer:     HTMLDivElement = document.querySelector('#ep-snow') as HTMLDivElement;

    public readonly mainSnowTable:       HTMLTableElement = document.querySelector('#ep-snow #tabsnih') as HTMLTableElement;

    public readonly searchBox:           HTMLInputElement = document.querySelector('#ep-snow input#snih-search') as HTMLInputElement;
    public readonly magnifyingGlassIcon: HTMLImageElement = document.querySelector('#ep-snow #snih-search-img') as HTMLImageElement;
    public readonly spinnerIcon:         HTMLImageElement = document.querySelector('#ep-snow img.search_spinner.search_ico') as HTMLImageElement;

    public hideMainSnowTable(): void
    {
        this.mainSnowTable.style.display = 'none';
    }

    public showMainSnowTable(): void
    {
        this.mainSnowTable.style.display = 'table';
    }

}